'use client'

import { useAlerts } from '@/hooks/useAlerts'
import { useEffect } from 'react'
import { Toaster } from 'sonner'

export function AlertProvider({ children }: { children: React.ReactNode }) {
  const { settings, testAlert } = useAlerts()

  // Auto-test on mount in development
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      // Test alert after 3 seconds
      const timer = setTimeout(() => {
        console.log('Testing alert system...')
        // Uncomment to auto-test: testAlert()
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [])

  return (
    <>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 5000,
          style: {
            background: 'var(--background)',
            color: 'var(--foreground)',
            border: '1px solid var(--border)'
          },
          className: 'font-sans'
        }}
      />
      {children}
    </>
  )
}